import React, { useEffect, useState } from 'react';
import { API } from '../../services';
import { NhgResponse } from '../../models/NhgResponse';
import { RemainingMortgageResponse } from '../../models/RemainingMortgageResponse';
import { RefinanceResponse } from '../../models/RefinanceReponse';
import { getDebugData } from '../../components/features/RefinanceStepper/formItems';

export type FormItem = { [key: string]: any };

interface FormContextProps {
	form: FormItem;
	isLoading: boolean;
	data: RefinanceResponse | null;
	nhg: NhgResponse | null;
	remainingMortgage: RemainingMortgageResponse | null;
	updateForm: (items: FormItem) => void;
	setRemainingMortgage: (data: RemainingMortgageResponse) => void;
	setIsLoading: (state: boolean) => void;
	updateData: (data: RefinanceResponse | null) => void;
}

export const FormContext = React.createContext<FormContextProps>({
	form: {},
	nhg: null,
	remainingMortgage: null,
	isLoading: false,
	data: null,
	updateForm: (items: FormItem) => {},
	setRemainingMortgage: (data: RemainingMortgageResponse | null) => {},
	setIsLoading: (state: boolean) => {},
	updateData: (data: RefinanceResponse | null) => null,
});

export const FormProvider: React.FC = ({children}) => {

	const [form, setForm] = useState({});
	const [nhg, setNhg] = useState<NhgResponse | null>(null);
	const [remainingMortgage, setRemainingMortgage] = useState<RemainingMortgageResponse | null>(null);
	const [isLoading, setIsLoading] = useState(false);
	const [data, setData] = useState<RefinanceResponse | null>(null);

	// debug
	useEffect(() => {
		updateForm(getDebugData())
		API.get<NhgResponse>('nhg').then((res) => setNhg(res))
		//API_MOCK.get<RefinanceResponse>('result.json').then((res) => setData(res))
	}, [setNhg])

	function updateForm(items: FormItem) {

		setForm({
			...form,
			...items,
		});

		//console.log(form, items);
	}

	function updateData(info: RefinanceResponse | null) {
		(info) ? setData({...info}) : setData(null)
	}

	return (
		<FormContext.Provider
			value={{
				isLoading,
				form,
				data,
				nhg,
				remainingMortgage,
				setRemainingMortgage,
				updateForm,
				setIsLoading,
				updateData,
			}}>
			{children}
		</FormContext.Provider>
	);
};
